import { Editor } from "@tinymce/tinymce-react";
import { Row, Col, Alert, Modal } from "react-bootstrap";
import Warning from "../formGenComponents/Warning";
import ContentInput from "../input/ContentInput";
import { State as Base} from "../input/ContentInput";
import { InputInterface } from "../component-base/input/interface/input";
import { createRef } from "react";
import ProjectRecord from "../../pages/projects/projectRecord";
import { ButtonComponent } from "../Buttons/ButtonComponent";
interface State extends Base{
    preview:boolean;
}
// project content editor with project record as preview
export default class ProjectContentEditor extends ContentInput{
    constructor(props:InputInterface) {
                super(props);
                this.handleImageUpload = this.handleImageUpload.bind(this);
                this.warningComponent=createRef();
                this.state = {
                    value:"",
                    warning:"",
                    alertVisible:false,
                    alertmessage:'',
                    alertVariant:'success',
                    preview:false
                }as State;
                this.timer = null;
    }
    previewRecord:Record<string,any>|null=null;

    public getState():State{
        return this.state as State;
    }
    public getPreviewRecord(){
        const form=this.props.formRef.current;
        return form.getRecord();
    }
    public showPreview(){
        this.previewRecord=this.getPreviewRecord();
        this.setState({...this.state as State,preview:true} as State);
    }

    render(){
            return(
                <Row>
                <Modal fullscreen={true} show={this.getState().preview} onHide={()=>{this.setState({...this.state,preview:false} as State)}}>
                <Modal.Header closeButton>
                <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <ProjectRecord preview={true} record={this.previewRecord}/>
                </Modal.Body>
                </Modal>
                <Col>
                {this.getState().alertVisible?
                <Alert variant={this.getState().alertVariant}>
                {this.getState().alertmessage}   
                </Alert>
                :null}
                <Editor
                onEditorChange={(value:string)=>this.onChangeValue(value)}
                apiKey={this.apiKey}
                value={this.getStateValue()}
                init={{
                    height:"800px",
                    plugins: [
                    // Core editing features
                    'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount','image media link lists'
                    ],
                    images_upload_handler: (blobInfo: any, progress: any) => this.handleImageUpload(blobInfo, progress),
                    automatic_uploads:true,
                    pasta_data_images:true,
                    toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography uploadcare | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                    tinycomments_mode: 'embedded',
                    tinycomments_author: 'Author name',
                    mergetags_list: [
                    { value: 'First.Name', title: 'First Name' },
                    { value: 'Email', title: 'Email' },
                    ],
                    ai_request: (request:any, respondWith:any) => respondWith.string(() => Promise.reject('See docs to implement AI Assistant')),
                    uploadcare_public_key: 'dfff09e4cb6c697f606a',
                    setup:this.handleEditorSetup
                }}
                />
                <Warning name={this.name} warning={this.getWarning()}/>
                <ButtonComponent caption="Preview" onClick={()=>this.showPreview()}/>
                </Col>
                </Row>
            )
        }
}